import type { CSSProperties, ReactNode } from "react";
import { cn } from "src/utilities/shadcnUtils";

interface Props {
  style?: CSSProperties;
  className?: string;
  children?: ReactNode;
}

const EmptyPage = ({ children, ...rest }: Props) => (
  <div {...rest} className={cn(rest.className, "bg-background")}>
    {children}
  </div>
);

export default EmptyPage;
